// import { KnBrOrderHistoryActions, KnBrOrderHistoryActionTypes } from './kn-br-order-history.action';
// import { KnBrOrderHistoryState } from './kn-br-order-history.state';

import { KnBrInvoiceState } from '../../../../../store/kn-br-invoice/kn-br-invoice.state';
import { KnBrInvoiceActions, KnBrInvoiceActionTypes } from '../actions/kn-br-invoice.action';

export const initialState: KnBrInvoiceState = {
  b2bDocuments: [],
  error: undefined,
  searchRequest: undefined,
  isLoading: false,
  pagination: undefined,
  sorts: undefined,
  isSearchDisabled: false,
  accountSummary: undefined,
};

export function knBrInvoiceReducer(state = initialState, action: KnBrInvoiceActions): KnBrInvoiceState {
  switch (action.type) {
    case KnBrInvoiceActionTypes.KnBrInvoiceSearchAction:
      return { ...state, searchRequest: action.payload, isLoading: true, isSearchDisabled: true };
    case KnBrInvoiceActionTypes.KnBrInvoiceSearchSuccessAction:
      return {
        ...state,
        b2bDocuments: [...state.b2bDocuments, ...action.payload.b2bDocuments],
        pagination: action.payload?.pagination,
        sorts: action.payload?.sorts,
        isLoading: false,
        isSearchDisabled: false,
      };
    case KnBrInvoiceActionTypes.KnBrInvoiceQuickSearchSuccessAction:
      return {
        ...state,
        b2bDocuments: action.payload?.b2bDocuments,
        pagination: action.payload?.pagination,
        sorts: action.payload?.sorts,
        isLoading: false,
        isSearchDisabled: false,
      };
    case KnBrInvoiceActionTypes.KnBrInvoiceSearchFailureAction:
      return { ...state, error: action.payload, isLoading: false, isSearchDisabled: false };
    case KnBrInvoiceActionTypes.KnBrInvoiceSearchResetAction:
      return { ...state, b2bDocuments: [], pagination: null, sorts: null, isLoading: true };
    case KnBrInvoiceActionTypes.KnBrInvoiceAccountSummarySuccessAction:
      return { ...state, accountSummary: action.payload };
    default:
      return state;
  }
}
